import styles from './AddArchive.module.scss';
import deletePhotoImg from '@assets/img/AdminPanel/delete.svg';
import FileComponent from '../FileComponent/FileComponent';
import { useEffect, useRef, useState } from 'react';
import { createArchive, uploadPhoto } from '../../../apirequests/apirequests';
import { useSelector } from 'react-redux';
import ImageCropper from '../../ImageCropper/ImageCropper';
import ErrorModal from '../../ErrorModal/ErrorModal';
import closeIcon from '@assets/img/AdminPanel/closeArchive.svg';

const ARCHIVE_EXTENSIONS = ['zip', 'rar', '7z'];
const MAX_ARCHIVE_SIZE = 1024 * 1024 * 1024; // 1 GB
const ERROR_FORMAT = 'Допустимый формат архива - .zip, .rar, .7z';
const ERROR_SIZE = 'Максимальный размер файла - 1Гб';
const ERROR_IMPORT = 'Ошибка при импорте файла';

const getArchiveUploadError = errorLike => {
  const data = errorLike?.response?.data || errorLike?.data;
  const errCode = data?.errCode;
  const message = data?.message || '';

  if (errCode === 'FileTooLarge' || /file too large|слишком больш|размер/i.test(message)) {
    return ERROR_SIZE;
  }
  if (
    errCode === 'FileExtensionNotAllowed' ||
    /extension|формат|not allowed/i.test(message)
  ) {
    return ERROR_FORMAT;
  }
  return ERROR_IMPORT;
};

function AddArchive(props) {
  const [file, setFile] = useState(null);
  const [name, setName] = useState('');
  const [url, setUrl] = useState('');
  const [archiveFile, setArchiveFile] = useState(null);
  const [errorName, setErrorName] = useState('');
  const [errorUrl, setErrorUrl] = useState('');
  const [errorArchive, setErrorArchive] = useState('');
  const [errorModal, setErrorModal] = useState(null);
  const textareaRef = useRef(null);
  const archiveInputRef = useRef(null);
  const conferenceid = useSelector(state => state.conferences?.data[0]?.id);
  const [fileUrl, setFileUrl] = useState(null);
  const [editPhoto, setEditPhoto] = useState(false);

  const handleFileChange = file => {
    if (file) {
      setFile(file);
      setFileUrl(URL.createObjectURL(file));
      setEditPhoto(true);
    } else {
      setFile(null);
      setFileUrl(null);
      setEditPhoto(false);
    }
  };

  const handleTextareaChange = e => {
    setUrl(e.target.value);
    setErrorUrl('');
    setErrorArchive('');
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      const newHeight = Math.min(textareaRef.current.scrollHeight, 87);
      textareaRef.current.style.height = `${newHeight}px`;
      textareaRef.current.style.overflowY = newHeight >= 87 ? 'auto' : 'hidden';
    }
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      const newHeight = Math.min(textareaRef.current.scrollHeight, 87);
      textareaRef.current.style.height = `${newHeight}px`;
    }
  }, []);

  const validateArchiveFile = file => {
    if (!file) return false;
    const extension = file.name.split('.').pop()?.toLowerCase();
    if (!ARCHIVE_EXTENSIONS.includes(extension)) {
      setErrorModal(ERROR_FORMAT);
      return false;
    }
    if (file.size > MAX_ARCHIVE_SIZE) {
      setErrorModal(ERROR_SIZE);
      return false;
    }
    return true;
  };

  const handleArchiveChange = e => {
    const selected = e.target.files?.[0];
    if (!selected) return;
    if (!validateArchiveFile(selected)) {
      e.target.value = null;
      return;
    }
    setArchiveFile(selected);
    setErrorArchive('');
    setErrorUrl('');
  };

  const removeArchiveFile = () => {
    setArchiveFile(null);
    if (archiveInputRef.current) archiveInputRef.current.value = null;
  };

  const spliceFileName = fileName => {
    if (!fileName) return '';
    if (fileName.length > 28) {
      const extension = fileName.split('.').pop();
      return `${fileName.slice(0, 28)}...${extension}`;
    }
    return fileName;
  };

  const createOrg = async () => {
    let valid = true;
    const trimmedUrl = url.trim();
    const hasUrl = trimmedUrl.length > 0;
    const hasArchive = Boolean(archiveFile);

    if (name === '') {
      setErrorName('Обязательное поле');
      valid = false;
    } else if (name.length > 250) {
      setErrorName('Не более 250 символов*');
      valid = false;
    } else {
      setErrorName('');
    }

    // Нужно заполнить хотя бы одно: ссылку или файл архива
    if (!hasUrl && !hasArchive) {
      setErrorUrl('Обязательное поле');
      setErrorArchive('');
      valid = false;
    } else {
      setErrorUrl('');
      setErrorArchive('');
    }

    if (trimmedUrl.length > 250) {
      setErrorUrl('Не более 250 символов*');
      valid = false;
    }

    if (!valid) return;

    const data = {
      name: name,
      url: hasUrl ? trimmedUrl : null,
      type: 0,
      conferenceId: conferenceid,
    };

    try {
      const resp = await createArchive(data);
      if (resp?.status === 200) {
        const archiveId = resp?.data?.archive?.id;

        if (file) {
          const formData = new FormData();
          formData.append('file', file);
          formData.append('archiveId', archiveId);
          await uploadPhoto(formData, 'PHOTO_ARCHIVE');
        }

        if (archiveFile) {
          const formData = new FormData();
          formData.append('file', archiveFile);
          formData.append('archiveId', archiveId);
          const uploadResp = await uploadPhoto(formData, 'ARCHIVE_ZIP');
          if (uploadResp?.status !== 200) {
            setErrorModal(getArchiveUploadError(uploadResp));
            return;
          }
        }

        props.updateData();
        props.close();
        setName('');
        setUrl('');
        setArchiveFile(null);
      }
    } catch (error) {
      console.error('Ошибка при создании архива:', error);
      setErrorModal(getArchiveUploadError(error));
    }
  };

  const funEditPhoto = file => {
    if (file) {
      setFile(file);
      setFileUrl(URL.createObjectURL(file));
      setEditPhoto(false);
    }
  };

  return (
    <>
      <ImageCropper
        editPhoto={editPhoto}
        setEditPhoto={setEditPhoto}
        urlPhoto={fileUrl}
        funEditPhoto={funEditPhoto}
        circularCrop={false}
      />
      <ErrorModal open={Boolean(errorModal)} close={() => setErrorModal(null)} title={errorModal} />
      <div className={styles.AddOrgPeople}>
        <div className={styles.AddOrgPeopleInner}>
          <div className={styles.addFile}>
            <div
              className={styles.file_cont}
              style={{ border: !file ? '2px dashed #C4C4C4' : 'none' }}
            >
              <div className={styles.border_inner}>
                <FileComponent
                  logoHeader={fileUrl}
                  data={file}
                  setData={handleFileChange}
                  typeFile={['image/png', 'image/jpg', 'image/jpeg']}
                  accept={'.png,.jpg,.jpeg,image/png,image/jpeg'}
                  name={'pngNews'}
                  icon={'png'}
                  text={'Нажмите или перетащите</br> изображение (.png, .jpg, .jpeg)'}
                />
              </div>
            </div>
          </div>

          <div className={styles.AddOrgPeopleInput}>
            <label>Название альбома</label>
            <input
              type="text"
              value={name}
              onChange={e => {
                setName(e.target.value);
                setErrorName('');
              }}
              style={{ borderColor: errorName ? '#B32020' : '' }}
            />
            {errorName && <span className={styles.error}>{errorName}</span>}
          </div>

          <div className={styles.AddOrgPeopleInput}>
            <label>Ссылка</label>
            <textarea
              ref={textareaRef}
              value={url}
              onChange={handleTextareaChange}
              style={{
                minHeight: '62px',
                maxHeight: '135px',
                overflowY: 'hidden',
                resize: 'none',
                borderColor: errorUrl ? '#B32020' : '',
              }}
            />
            {errorUrl && <span className={styles.error}>{errorUrl}</span>}
          </div>

          <div className={styles.AddOrgPeopleInput}>
            <label>Файл архива</label>
            <input
              type="file"
              ref={archiveInputRef}
              accept=".zip,.rar,.7z"
              style={{ display: 'none' }}
              onChange={handleArchiveChange}
            />
            {archiveFile ? (
              <div className={styles.archiveChip}>
                <span>{spliceFileName(archiveFile.name)}</span>
                <button type="button" onClick={removeArchiveFile} aria-label="Удалить файл">
                  <img src={closeIcon} alt="" />
                </button>
              </div>
            ) : (
              <button
                type="button"
                className={styles.archiveUploadBtn}
                onClick={() => archiveInputRef.current?.click()}
                style={{ borderColor: errorArchive ? '#B32020' : '' }}
              >
                + Загрузите архив
              </button>
            )}
            {errorArchive && <span className={styles.error}>{errorArchive}</span>}
          </div>

          <div className={styles.AddOrgPeopleButton}>
            <button className={styles.save} onClick={createOrg}>
              Сохранить
            </button>
            <button className={styles.delete} onClick={props.close}>
              <img src={deletePhotoImg} alt="Удалить" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddArchive;
